"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.active.help': 'Inactive avatars are not visible to normal users',
};
